<template>
  <a-modal v-model="modal" title="请输入目的仓套数" width="650px" :maskClosable="false" :closable="false">
    <a-form-model :model="formData" ref="form">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item
            label="佛山仓（套）"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
            prop="cpDivideQty"
            :rules="rules.cpDivideQty"
          >
            <a-input-number
              :parser="(value) => `${value}`.replace(/\D/g, '')"
              :formatter="(value) => `${value}`.replace(/\D/g, '')"
              style="width: 100%;"
              placeholder="请输入佛山仓套数"
              v-model="formData.cpDivideQty"
              :min="minValues.cpDivideQty"
              :max="getMaxValue('cpDivideQty')"
              @change="divideQtyChange('cpDivideQty', $event)"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <div class="mt10">当前佛山仓{{ formData.currentCpDivideQty }}（套），已入库{{ formData.currentCpReceiveQty }}套</div>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item
            label="卫星仓（套）"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
            prop="wxcDivideQty"
            :rules="rules.wxcDivideQty"
          >
            <a-input-number
              :parser="(value) => `${value}`.replace(/\D/g, '')"
              :formatter="(value) => `${value}`.replace(/\D/g, '')"
              style="width: 100%;"
              placeholder="请输入卫星仓套数"
              v-model="formData.wxcDivideQty"
              :min="minValues.wxcDivideQty"
              :max="getMaxValue('wxcDivideQty')"
              @change="divideQtyChange('wxcDivideQty', $event)"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <div class="mt10">当前卫星仓{{ formData.currentWxcDivideQty }}（套），已入库{{ formData.currentWxcReceiveQty }}套</div>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item
            label="基地仓理货（套）"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
            prop="jdc002DivideQty"
            :rules="rules.jdc002DivideQty"
          >
            <a-input-number
              :parser="(value) => `${value}`.replace(/\D/g, '')"
              :formatter="(value) => `${value}`.replace(/\D/g, '')"
              style="width: 100%;"
              placeholder="请输入基地仓理货套数"
              v-model="formData.jdc002DivideQty"
              :min="minValues.jdc002DivideQty"
              :max="getMaxValue('jdc002DivideQty')"
              @change="divideQtyChange('jdc002DivideQty', $event)"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <div class="mt10">当前基地仓理货{{ formData.currentJdc002DivideQty }}（套），已入库{{ formData.currentJdc002ReceiveQty }}套</div>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item
            label="基地仓（套）"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
            prop="jdcDivideQty"
          >
            <a-input-number style="width: 100%;" v-model="formData.jdcDivideQty" disabled />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <div class="mt10">当前基地仓{{ formData.currentJdcDivideQty }}（套），已入库{{ formData.currentJdcReceiveQty }}套</div>
        </a-col>
      </a-row>
    </a-form-model>
    <template #footer>
      <a-space>
        <a-button @click="modal=false;$refs.form.resetFields();">取消</a-button>
        <a-button type="primary" @click="submit" :loading="loading">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import {
  apiMesGetDivideWarehouseQty,
  apiUpdateDestinationQty
} from '@/api/mes/workOrderManage/workOrderDesk'
export default {
  name: 'DestinationWarehouseModal',
  data () {
    return {
      modal: false,
      selectedRow: [],
      destinationList: [],
      minValues: {
        cpDivideQty: 0,
        wxcDivideQty: 0,
        jdc002DivideQty: 0
      },
      formData: {
        cpDivideQty: 0, // 佛山仓分仓数量
        wxcDivideQty: 0, // 卫星仓分仓数量
        jdc002DivideQty: 0, // 基地仓理货分仓数量
        jdcDivideQty: 0, // 基地仓分仓数量
        currentCpDivideQty: 0, // 当前佛山仓分仓数量
        currentCpReceiveQty: 0, // 当前佛山仓已入库数量
        currentWxcDivideQty: 0, // 当前卫星仓分仓数量
        currentWxcReceiveQty: 0, // 当前卫星仓已入库数量
        currentJdc002DivideQty: 0, // 当前基地仓理货分仓数量
        currentJdc002ReceiveQty: 0, // 当前基地仓理货已入库数量
        currentJdcDivideQty: 0, // 当前基地仓分仓数量
        currentJdcReceiveQty: 0 // 当前基地仓已入库数量
      },
      rules: {
        cpDivideQty: [{ required: true, message: ' ', trigger: 'change' }],
        wxcDivideQty: [{ required: true, message: ' ', trigger: 'change' }],
        jdc002DivideQty: [{ required: true, message: ' ', trigger: 'change' }]
      },
      loading: false
    }
  },
  computed: {
    // 联动总数始终等于接口返回的四个当前分仓数量之和
    divideWarehouseTotal() {
      const {
        currentCpDivideQty,
        currentJdcDivideQty,
        currentWxcDivideQty,
        currentJdc002DivideQty
      } = this.formData
      return Number(currentCpDivideQty || 0) +
        Number(currentJdcDivideQty || 0) +
        Number(currentWxcDivideQty || 0) +
        Number(currentJdc002DivideQty || 0)
    }
  },
  methods: {
    // 限制本次输入不超过剩余可分配数量，基地仓数量由总数减去其他三仓数量得到
    divideQtyChange(field, value) {
      const editableQty = {
        cpDivideQty: this.formData.cpDivideQty,
        wxcDivideQty: this.formData.wxcDivideQty,
        jdc002DivideQty: this.formData.jdc002DivideQty
      }
      if (field) {
        const maxValue = Math.max(0, this.getMaxValue(field))
        const minValue = Math.min(Number(this.minValues[field] || 0), maxValue)
        const inputValue = Number.isFinite(Number(value)) ? Math.trunc(Number(value)) : 0
        editableQty[field] = Math.min(Math.max(inputValue, minValue), maxValue)
        this.$set(this.formData, field, editableQty[field])
      }
      const { cpDivideQty, wxcDivideQty, jdc002DivideQty } = editableQty
      const jdcDivideQty = this.divideWarehouseTotal - Number(cpDivideQty || 0) - Number(wxcDivideQty || 0) - Number(jdc002DivideQty || 0)
      this.$set(this.formData, 'jdcDivideQty', Math.max(0, jdcDivideQty))
    },
    // 单个可编辑仓的最大值需预留其他仓当前数量及基地仓已入库数量
    getMaxValue(field) {
      const editableFields = ['cpDivideQty', 'wxcDivideQty', 'jdc002DivideQty']
      const otherQty = editableFields
        .filter(item => item !== field)
        .reduce((total, item) => total + Number(this.formData[item] || 0), 0)
      return this.divideWarehouseTotal - Number(this.formData.currentJdcReceiveQty) - otherQty
    },
    show (row) {
      this.selectedRow = row
      this.getData();
      this.modal = true
    },
    /**
     * 修改目的仓(数据只能是整数)
     总数 = 佛山仓 + 卫星仓 + 基地仓理货 + 基地仓
     基地仓不能编辑 = 总数 - 佛山仓 - 卫星仓 - 基地仓理货
     每个仓的分仓数量不能小于该仓已入库数量
     */
    getData() {
      this.formData = {
        cpDivideQty: 0, // 佛山仓分仓数量
        wxcDivideQty: 0, // 卫星仓分仓数量
        jdc002DivideQty: 0, // 基地仓理货分仓数量
        jdcDivideQty: 0, // 基地仓分仓数量
        currentCpDivideQty: 0, // 当前佛山仓分仓数量
        currentCpReceiveQty: 0, // 当前佛山仓已入库数量
        currentWxcDivideQty: 0, // 当前卫星仓分仓数量
        currentWxcReceiveQty: 0, // 当前卫星仓已入库数量
        currentJdc002DivideQty: 0, // 当前基地仓理货分仓数量
        currentJdc002ReceiveQty: 0, // 当前基地仓理货已入库数量
        currentJdcDivideQty: 0, // 当前基地仓分仓数量
        currentJdcReceiveQty: 0 // 当前基地仓已入库数量
      }
      this.minValues = {
        cpDivideQty: 0,
        wxcDivideQty: 0,
        jdc002DivideQty: 0
      }
      this.loading = true
      apiMesGetDivideWarehouseQty({ id: this.selectedRow.id }).then(res => {
        if (res.code === 200) {
          const data = res?.data || {}
          this.$set(this.formData, 'currentCpDivideQty', data?.currentCpDivideQty || 0)
          this.$set(this.formData, 'currentCpReceiveQty', data?.currentCpReceiveQty || 0)
          this.$set(this.formData, 'currentWxcDivideQty', data?.currentWxcDivideQty || 0)
          this.$set(this.formData, 'currentWxcReceiveQty', data?.currentWxcReceiveQty || 0)
          this.$set(this.formData, 'currentJdc002DivideQty', data?.currentJdc002DivideQty || 0)
          this.$set(this.formData, 'currentJdc002ReceiveQty', data?.currentJdc002ReceiveQty || 0)
          this.$set(this.formData, 'currentJdcDivideQty', data?.currentJdcDivideQty || 0)
          this.$set(this.formData, 'currentJdcReceiveQty', data?.currentJdcReceiveQty || 0)
          this.$set(this.formData, 'cpDivideQty', data?.currentCpDivideQty || 0)
          this.$set(this.formData, 'wxcDivideQty', data?.currentWxcDivideQty || 0)
          this.$set(this.formData, 'jdc002DivideQty', data?.currentJdc002DivideQty || 0)
          this.minValues = {
            cpDivideQty: Number(this.formData.currentCpReceiveQty),
            wxcDivideQty: Number(this.formData.currentWxcReceiveQty),
            jdc002DivideQty: Number(this.formData.currentJdc002ReceiveQty)
          }
          this.divideQtyChange()
        } else {
          this.$message.error(res.msg)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 确认修改
    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.divideQtyChange()
          const destinationQtyList = [
            { destination: 'CP', divideQty: Number(this.formData.cpDivideQty) },
            { destination: 'WXC', divideQty: Number(this.formData.wxcDivideQty) },
            { destination: 'JDC002', divideQty: Number(this.formData.jdc002DivideQty) },
            { destination: 'JDC001', divideQty: Number(this.formData.jdcDivideQty) }
          ]
          const divideQtyTotal = destinationQtyList.reduce((total, item) => total + item.divideQty, 0)
          const hasInvalidQty = destinationQtyList.some(item => !Number.isInteger(item.divideQty) || item.divideQty < 0)
          if (hasInvalidQty || divideQtyTotal !== this.divideWarehouseTotal) {
            this.$message.error('各目的仓数量不能为负数，且四个仓数量之和必须等于原分仓总数')
            return
          }
          this.loading = true
          apiUpdateDestinationQty({ id: this.selectedRow.id, destinationQtyList }).then(res => {
            if (res.code === 200) {
              this.$message.success(res.msg)
              this.modal = false
              this.$emit('handle-success')
            } else {
              this.$message.error(res.msg)
            }
          }).finally(() => {
            this.loading = false
          })
        } else {
          return false
        }
      })
    }
  },
  created() {}
}
</script>

<style scoped>

</style>
